import React from 'react';

const DeskAvailabilityCard = ({ data = [], loading = false, width = '100%', height = 'auto', maxWidth = '416px', maxHeight = '287px' }) => {
  /* ---------- Extract data ---------- */
  const d0 = data?.[0] || {};
  const withoutVest = Number(d0?.kit?.[0]?.total_unique_keys ?? 0);
  const withoutHelmet = Number(d0?.helmet?.[0]?.total_unique_keys ?? 0);
  const withoutShoes = Number(d0?.shoes?.[0]?.total_unique_keys ?? 0);
  const totalEvents = withoutVest + withoutHelmet + withoutShoes;

  /* ---------- SVGs ---------- */
  const ShieldSVG = ({ size = 52 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 52 52" fill="none" className="svg-fixed">
      <path
        d="M24.4832 4.89665L11.4832 9.77165C9.79317 10.4216 8.6665 12.025 8.6665 13.845V24.0283C8.6665 34.4933 15.4482 44.33 24.7648 47.32C25.5665 47.58 26.4332 47.58 27.2348 47.32C36.5515 44.33 43.3332 34.515 43.3332 24.0283V13.845C43.3316 12.9633 43.0612 12.103 42.5579 11.3791C42.0546 10.6551 41.3424 10.1019 40.5165 9.79331L27.5165 4.91831C26.5415 4.52831 25.4582 4.52831 24.4832 4.89665ZM25.9998 36.8333C20.0198 36.8333 15.1665 31.98 15.1665 26C15.1665 20.02 20.0198 15.1666 25.9998 15.1666C31.9798 15.1666 36.8332 20.02 36.8332 26C36.8332 31.98 31.9798 36.8333 25.9998 36.8333ZM30.3332 30.3333C29.8998 30.7666 29.2282 30.7666 28.7948 30.3333L25.2198 26.7583C25.0157 26.5583 24.8989 26.2857 24.8948 26V20.5833C24.9165 19.9766 25.3932 19.5 25.9998 19.5C26.6065 19.5 27.0832 19.9766 27.0832 20.5833V25.545L30.3332 28.795C30.7665 29.2283 30.7665 29.9 30.3332 30.3333Z"
        fill="#FF4F4F"
      />
    </svg>
  );

  const VestSVG = ({ size = 24 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" className="svg-fixed">
      <path
        d="M5.963 4.919C6.045 3.902 6.876 3 8 3H16C17.124 3 17.955 3.902 18.037 4.919C18.2103 7.03792 18.9815 9.06412 20.261 10.762C20.685 11.316 21 12.032 21 12.828V18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21H14C13.7348 21 13.4804 20.8946 13.2929 20.7071C13.1054 20.5196 13 20.2652 13 20V11.285C13 10.427 13.592 9.688 14.202 9.085C14.735 8.557 15.13 7.867 15.406 7.197C15.6184 6.67205 15.7824 6.12879 15.896 5.574C15.9101 5.50368 15.9082 5.4311 15.8905 5.3616C15.8728 5.2921 15.8398 5.22745 15.7938 5.17239C15.7479 5.11733 15.6902 5.07326 15.625 5.04343C15.5598 5.0136 15.4887 4.99876 15.417 5H8.583C8.5113 4.99876 8.44023 5.0136 8.37502 5.04343C8.3098 5.07326 8.2521 5.11733 8.20616 5.17239C8.16021 5.22745 8.12718 5.2921 8.1095 5.3616C8.09183 5.4311 8.08995 5.50368 8.104 5.574C8.21758 6.12879 8.38159 6.67205 8.594 7.197C8.87 7.867 9.264 8.557 9.798 9.084C10.408 9.688 11 10.427 11 11.285V20C11 20.2652 10.8946 20.5196 10.7071 20.7071C10.5196 20.8946 10.2652 21 10 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V12.828C3 12.031 3.315 11.316 3.74 10.762C4.45 9.832 5.73 7.792 5.963 4.919Z"
        fill="#F1963A"
      />
    </svg>
  );

  const HelmetSVG = ({ size = 24 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" className="svg-fixed">
      <path
        d="M15.0556 11.2639V3.27778C15.0556 2.57101 14.4845 2 13.7778 2H11.2222C10.5155 2 9.94444 2.57101 9.94444 3.27778V11.2639C9.94444 11.795 9.51719 12.2222 8.98611 12.2222C8.45503 12.2222 8.02778 11.795 8.02778 11.2639V3.8408C4.59375 5.1066 2.27778 8.3809 2.27778 12.2222V14.7778H22.7222V12.2222C22.6823 8.42083 20.3903 5.12656 16.9722 3.84479V11.2639C16.9722 11.795 16.545 12.2222 16.0139 12.2222C15.4828 12.2222 15.0556 11.795 15.0556 11.2639ZM2.59722 16.6944C1.71476 16.6944 1 17.4092 1 18.2917C1 19.1741 1.71476 19.8889 2.59722 19.8889H22.4028C23.2852 19.8889 24 19.1741 24 18.2917C24 17.4092 23.2852 16.6944 22.4028 16.6944H2.59722Z"
        fill="#2CD9FF"
      />
    </svg>
  );

  const ShoesSVG = ({ size = 24 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className="svg-fixed"
      aria-label="Shoes"
    >
      <path d="M3 13c3 0 5 .5 8 2 1 .6 2 1 3 1h3c1.657 0 3 1.343 3 3v1H3c-1.105 0-2-.895-2-2v-3c0-1.105.895-2 2-2Z" fill="#A78BFA" />
      <path
        d="M11 6c.667 1.333 2.6 3.4 4 4 .8.3 1.667.667 2 .5.333-.167.667-1.167 1-1 .333.167.667 1 1 1.5.333.5 1 1.5 1 2h-3c-1.333 0-2.667-.333-3.5-.833C10.5 10.5 8 9.5 6 9V7c0-1.657 1.343-3 3-3 1.333 0 2.333.667 2 2Z"
        fill="#C4B5FD"
      />
    </svg>
  );

  /* ---------- Small stat row ---------- */
  const StatRow = ({ icon, value, label, isLast }) => (
    <div>
      <div className="row">
        <div className="row-icon">{icon}</div>
        <div className="row-text">
          <div className="row-val">
            <span className="row-val-strong">{value}</span>
          </div>
          <div className="row-label">{label}</div>
        </div>
      </div>
      {!isLast && <div className="divider" />}
    </div>
  );

  /* ---------- Component ---------- */
  return (
    <div className="desk-card" style={{ width, height, maxWidth, maxHeight, minWidth: '280px' }}>
      {/* Embedded styles so this stays single-file */}
      <style>{`
        .desk-card{position:relative;border-radius:20px;background:linear-gradient(127deg,rgba(6,11,40,0.94) 19.41%,rgba(10,14,35,0.49) 76.65%);backdrop-filter:blur(60px);-webkit-backdrop-filter:blur(60px);padding:clamp(16px, 4vw, 24px);color:#fff;overflow:hidden;box-shadow:0 12px 28px rgba(0,0,0,0.45);font-family:ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, "Helvetica Neue", Arial, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji"}
        .svg-fixed{width:inherit;height:inherit;flex-shrink:0;aspect-ratio:1/1}
        .pill{position:relative;width:100%;height:clamp(90px, 12vw, 103px);border-radius:18px;padding:clamp(12px, 3vw, 20px);display:flex;align-items:center;color:#fff;overflow:hidden;background:linear-gradient(180deg,rgba(20,31,74,0.9) 0%,rgba(12,18,48,0.9) 100%);box-shadow:inset 0 0 0 1px rgba(86,129,255,0.55),0 8px 22px rgba(0,0,0,0.35)}
        .pill-slope{position:absolute;right:-20%;top:0;bottom:0;width:70%;transform:skewX(-18deg);background:linear-gradient(180deg,rgba(7,12,32,0.65) 0%,rgba(7,12,32,0.2) 100%);filter:blur(.2px)}
        .pill-title{font-size:clamp(14px, 2.5vw, 16px);font-weight:600;margin-bottom:8px;display:flex;align-items:center;gap:8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
        .pill-metric{display:flex;align-items:baseline;gap:8px}
        .pill-metric .val{font-size:clamp(28px, 6vw, 40px);font-weight:300;line-height:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
        .pill-metric .sub{font-size:clamp(10px, 2vw, 12px);opacity:.8;flex-shrink:0}
        .shield{position:absolute;right:clamp(12px, 3vw, 18px);top:50%;transform:translateY(-50%);z-index:3;flex-shrink:0}
        .section-title{margin-top:clamp(14px, 3vw, 18px);font-size:clamp(10px, 2vw, 12px);letter-spacing:1.4px;color:rgba(226,232,240,0.75);margin-bottom:10px}
        .stats-scroll{height:clamp(120px, 20vw, 140px);overflow-y:auto;padding-right:8px;scrollbar-width:none !important;-ms-overflow-style:none !important;}
        .stats-scroll::-webkit-scrollbar{display:none !important;width:0 !important;height:0 !important;}
        .stats-scroll::-webkit-scrollbar-track{display:none !important;}
        .stats-scroll::-webkit-scrollbar-thumb{display:none !important;}
        .stats-scroll::-webkit-scrollbar-corner{display:none !important;}
        .row{display:flex;align-items:center;gap:clamp(8px, 2vw, 12px);margin-bottom:10px}
        .row-icon{width:clamp(32px, 5vw, 36px);height:clamp(32px, 5vw, 36px);border-radius:50%;background:rgba(86,129,255,0.18);display:flex;align-items:center;justify-content:center;outline:1px solid rgba(86,129,255,0.35);flex-shrink:0}
        .row-text{display:flex;align-items:center;gap:8px;min-width:0;flex:1}
        .row-val{font-size:18px;font-weight:700;line-height:1.1}
        .row-val-strong{font-size:clamp(18px, 3.5vw, 22px);font-weight:800;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
        .row-label{font-size:clamp(11px, 2vw, 13px);color:rgba(226,232,240,0.7);flex-shrink:0}
        .divider{margin:14px 0;height:1px;background-color:rgba(255,255,255,0.06)}
        .radial{position:absolute;top:-40%;right:-20%;width:360px;height:360px;border-radius:50%;background:radial-gradient(closest-side,rgba(255,255,255,0.06),rgba(255,255,255,0));pointer-events:none;filter:blur(2px)}
        .skeleton-outer{width:100%;height:110px;border-radius:18px;background:linear-gradient(180deg,rgba(255,255,255,0.08),rgba(255,255,255,0.04));outline:1px solid rgba(120,153,255,0.15);margin-bottom:24px}
        .sk{background-color:rgba(255,255,255,0.10);border-radius:6px}
      `}</style>

      {loading ? (
        <>
          <div className="skeleton-outer" />
          <div className="sk" style={{ width: '24%', height: 26, marginBottom: 10 }} />
          <div className="sk" style={{ width: '36%', height: 22, marginBottom: 10 }} />
          <div className="sk" style={{ width: '30%', height: 22 }} />
        </>
      ) : (
        <>
          {/* Header pill */}
          <div className="pill">
            <div className="pill-slope" />
            <div style={{ position: 'relative', zIndex: 2, flex: 1 }}>
              <div className="pill-title">Safety Breaches</div>
              <div className="pill-metric">
                <div className="val">{totalEvents}</div>
                <div className="sub">Total Events</div>
              </div>
            </div>
            <div className="shield">
              <ShieldSVG size={window.innerWidth < 480 ? 36 : 52} />
            </div>
          </div>

          {/* STATISTICS list */}
          <div className="section-title">STATISTICS</div>
          <div className="stats-scroll">
            <StatRow icon={<VestSVG />} value={withoutVest} label="Without Vest" />
            <StatRow icon={<HelmetSVG />} value={withoutHelmet} label="Without Helmet" />
            <StatRow icon={<ShoesSVG />} value={withoutShoes} label="Without Shoes" />
          </div>
        </>
      )}

      <div className="radial" />
    </div>
  );
};

export default DeskAvailabilityCard;
